export const ERROR_FROM_PROGRAM_LOGIC = '예상치 못한 에러'
export const ERROR_FROM_ADULT_VERIFICATION_PIN_CODE =
  '성인인증 비밀번호 설정에 실패 했습니다.'
export const CONFIRM_CHILDREN_PROTECTION_MESSAGE_HTML =
  '자녀보호를 위한 설정으로<br/>성인만 설정 가능합니다.<br/><br/>성인 인증과 비밀번호가 모두 설정되어야 합니다.'
export const CONFIRM_RESET_CHILDREN_PROTECTION_CODE_HTML =
  '성인 비밀번호를<br/>초기화하시겠습니까?<br/><br/>초기화하면 기존 성인 비밀번호는 삭제되며<br/>성인인증 후 새로운 비밀번호를 설정합니다.'
export const WHEN_USER_ALLOW_BLOCK_POPUP = '팝업차단 해제 후 이용해주세요.'
export const TOAST_MSG_NETWORK_ERROR = `서비스 연결이 지연되고 있습니다.\n잠시 후 이용해 주세요.\n증상 지속 시 Wavve 고객센터로 문의해 주세요.`
